<template>
  <v-container>
        <v-card>
      <v-row>
        <v-col
          class="text-right"
          cols="12"
        >
        </v-col>
       </v-row>
    <v-form>
      <v-container>
        <v-row>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="libro.isbn"
              :disabled="isUpdating"
              filled
              color="blue-grey lighten-2"
              label="ISBN"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="libro.codigo_inventario"
              :disabled="isUpdating"
              filled
              color="blue-grey lighten-2"
              label="Código inventario"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="libro.titulo"
              :disabled="isUpdating"
              filled
              color="blue-grey lighten-2"
              label="Título"
            ></v-text-field>
          </v-col>
           <v-col cols="12" md="6">
            <v-text-field
              v-model="libro.existencia"
              :disabled="isUpdating"
              filled
              color="blue-grey lighten-2"
              label="Existencia"
              type="number"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
            :items="editoriales"
            :filter="customFilter"
            color="white"
            item-text="name"
            label="Editorial"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
            :items="categorias"
            :filter="customFilter"
            color="white"
            item-text="name"
            label="Categoria"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
            :items="ediciones"
            :filter="customFilter"
            color="white"
            item-text="name"
            label="Edicion"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
            :items="anios"
            :filter="customFilter"
            color="white"
            item-text="anio"
            label="Año"
            >
            </v-autocomplete>
          </v-col>


        </v-row>
      </v-container>
    </v-form>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        :disabled="autoUpdate"
        :loading="isUpdating"
        depressed
        color="blue-grey darken-3"
        @click="isUpdating = true"
      >
        <v-icon left>mdi-update</v-icon>
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="autoUpdate"
        :loading="isUpdating"
        @click="isUpdating = true"
      >
        <v-icon left>mdi-update</v-icon>
        Almacenar
      </v-btn>
    </v-card-actions>
  </v-card>
  </v-container>
</template>


<script>
//Flujo de funcionamiento, el usuario ingresa los datos del libro seleccionando autores, categoría, etc, 
//luego agrega al listado la cantidad y edición con la que cuentan del libro y luego guarda
import { debuglog } from "util";
export default {
  data: () => ({

      editoriales:[],
      categorias:[],
      edicion:[],
      anio:[{"anio":1950},],
      libro:{
        isbn:"",
        codigo_invetario:"",
        titulo:"",
      }

  }),
 
  created() {
   
  },

    

  methods: {
    validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
  }
};
</script>